export const MODULE_PERMISSION = {
    COST_CODE: 1,
    COST_MANAGER: 2,
    BUDGET: 3,
    PROPERTYX: 4,
};

export const BUDGET_MODULE_PERMISSION = {
    BUDGET: 1,
    PURCHASE_REQUEST: 2,
    REQUEST_TO_TENDER: 3,
    PURCHASE_ORDER: 4,
    E_INVOICE: 5,
    GOODS_RECEIPT_NOTE: 6,
    REQUEST_FOR_QUOTATION: 7,
};

export const COST_ITEM = {
    TYPE_HEAD: 1,
    TYPE_ITEM: 2,
};

// add on as required
export const STATUS_CODES = {
    PREPARING: 'preparing',
    PENDING_APPROVAL: 'pending_approval',
    APPROVED: 'approved',
};

export const MODULE_PROPERTY_LISTING = {
    PROPERTY_LISTING: 1,
};